import React, { createContext, useContext, useState } from 'react';

const TextExpansionContext = createContext();

export const useTextExpansion = () => {
  const context = useContext(TextExpansionContext);
  if (!context) {
    throw new Error('useTextExpansion must be used within a TextExpansionProvider');
  }
  return context;
};

export const TextExpansionProvider = ({ children }) => {
  const [isTextExpanded, setIsTextExpanded] = useState(false);

  const handleTextExpansion = (expanded) => {
    console.log('🔄 handleTextExpansion called with expanded:', expanded);
    setIsTextExpanded(expanded);
    
    // Dynamically adjust player container height
    const playerContainer = document.querySelector('#player-container') || 
                           document.querySelector('#series-player-container') ||
                           document.querySelector('#series-player');
    
    console.log('Found playerContainer:', !!playerContainer);
    
    if (playerContainer) {
      console.log('Current computed height:', window.getComputedStyle(playerContainer).height);
      console.log('Current inline height:', playerContainer.style.height);
      
      if (expanded) {
        // Set fixed height of 600px when expanded with !important to override CSS
        console.log('🔄 Setting expanded height to: 600px');
        // playerContainer.style.setProperty('height', '600px', 'important');
        playerContainer.style.setProperty('min-height', '600px', 'important');
        playerContainer.style.setProperty('max-height', 'none', 'important');
        
        // Verify the change was applied
        setTimeout(() => {
          console.log('After change - computed height:', window.getComputedStyle(playerContainer).height);
          console.log('After change - inline height:', playerContainer.style.height);
        }, 100);
      } else {
        // Reset to original height when collapsed
        console.log('🔄 Resetting to collapsed height');
        playerContainer.style.removeProperty('height');
        playerContainer.style.removeProperty('min-height');
        playerContainer.style.removeProperty('max-height');
      }
    } else {
      console.warn('❌ Could not find player container for height adjustment');
    }
  };

  const stopVideoPlayer = () => {
    console.log('🛑 Attempting to stop video player...');
    
    // Try to find the VideoJS player instance
    const videoElement = document.querySelector('.video-js');
    if (videoElement && videoElement.player) {
      console.log('✅ Found VideoJS player, stopping...');
      videoElement.player.pause();
      return true;
    }
    
    // Fallback: try to find video element directly
    const videoTag = document.querySelector('video');
    if (videoTag) {
      console.log('✅ Found video element, pausing...');
      videoTag.pause();
      return true;
    }
    
    console.warn('❌ Could not find video player to stop');
    return false;
  };

  const value = {
    isTextExpanded,
    handleTextExpansion,
    stopVideoPlayer,
  };

  return (
    <TextExpansionContext.Provider value={value}>
      {children}
    </TextExpansionContext.Provider>
  );
};
